const flatten = list => list.reduce(
    (a, b) => a.concat(Array.isArray(b) ? flatten(b) : b), []
);

export default function selectFilters(filters) {
    const data = [];

    filters.forEach(function(filter) {
        if (filter.selected) {
            data.push({
                id: filter.id,
                label: filter.label,
            });
        }

        if (filter.children) {
            data.push(selectFilters(filter.children));
        }
    });

    return flatten(data);
};



// WEBPACK FOOTER //
// ./src/scripts/SelectFilters.js